"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const clone_1 = tslib_1.__importDefault(require("lodash/clone"));
const baseZeroState_1 = tslib_1.__importDefault(require("./baseZeroState"));
function courseZeroState(content, user) {
    try {
        const baseState = baseZeroState_1.default(content, user);
        const courseState = clone_1.default(baseState);
        courseState.unitsCompleted = 0;
        return courseState;
    }
    catch (error) {
        throw new Error('Error in courseZeroState ' + error);
    }
}
exports.default = courseZeroState;
//# sourceMappingURL=courseZeroState.js.map